import ACTIONS from "./actionTypes"

export const getCurrentPath = path => ({
  type: ACTIONS.GET_CURRENT_PATH,
  path,
})
